module.exports = __webpack_public_path__ + "static/media/york-10.02adab60.jpg";